// @ts-ignore
import { uploadFile } from 'react-s3'

export const uploadFileToStorage = async (
  file: File,
  modelId: string
): Promise<string> => {
  const s3Config = {
    bucketName: process.env.REACT_APP_S3_BUCKET as string,
    dirName: `babylonjs/models/${modelId}`,
    region: process.env.REACT_APP_S3_REGION as string,
    accessKeyId: process.env.REACT_APP_S3_ACCESS_KEY as string,
    secretAccessKey: process.env.REACT_APP_S3_SECRET_KEY as string,
  }

  const res = await uploadFile(file, s3Config)

  if (res.location) {
    return res.location
  } else {
    throw new Error('Uploading is not successful.')
  }
}
